import React from 'react';
import { COMPLIANCE } from '@/constants/testIds';

export default function ComplianceModal({ open, complianceType, setComplianceType, onSubmit, onClose }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-6">
      <div className="bg-white rounded-sm max-w-md w-full p-8">
        <h2 className="text-2xl font-bold mb-6" style={{ fontFamily: 'Outfit' }}>New Compliance Checklist</h2>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-black mb-2">Checklist Type</label>
            <select
              data-testid={COMPLIANCE.typeSelect}
              value={complianceType}
              onChange={(e) => setComplianceType(e.target.value)}
              className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:ring-2 focus:ring-blue-600"
            >
              <option value="building_permit">Building Permit</option>
              <option value="structural">Structural</option>
              <option value="electrical">Electrical</option>
              <option value="plumbing">Plumbing</option>
              <option value="fire_safety">Fire Safety</option>
            </select>
          </div>
          <div className="flex gap-4 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-6 py-3 border border-slate-300 rounded-sm hover:bg-slate-50 transition-all"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 px-6 py-3 bg-black text-white rounded-sm hover:bg-slate-800 transition-all"
            >
              Create Checklist
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
